<script>
import Category from "@/views/components/category.vue";
import ShopOption from "@/views/components/shopOption.vue";
import UploadList from "@/views/components/uploadList.vue";
import { formatApiDate, getFileName } from "@/utils/utils";
import {
  DIALOG_TITLE_TYPE,
  PRODUCT_TYPE,
  UPLOAD_IMG_TYPE,
  PRODUCT_DELIVERY_TIME,
  PRODUCT_TYPE_TAG,
  YES_NO_LIST
} from "@/utils/enumUtile";
import {
  editGoods,
  getGoodsEditDetail,
  getGiftConfigs,
  deleteGoodsSpecs,
} from "@/api/product";
import { getPostagesList } from "@/api/store";
import { uploadImage } from "@/api/common";
import { Message } from "element-ui";
import moment from "moment";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { isRef } from "vue";

export default {
  name: "addOrEditProduct",
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    },
    PRODUCT_TYPE_LIST() {
      return PRODUCT_TYPE;
    },
    PRODUCT_DELIVERY_TIME() {
      return PRODUCT_DELIVERY_TIME;
    },
    PRODUCT_TYPE_TAG() {
      return PRODUCT_TYPE_TAG;
    },
    YES_NO_LIST(){
      return YES_NO_LIST
    }
  },
  components: { Category, UploadList, quillEditor, ShopOption },
  data() {
    return {
      rules: {
        shopId: [
          { required: true, message: "店铺不能为空", trigger: "change" },
        ],
        type: [
          { required: true, message: "商品类型不能为空", trigger: "change" },
        ],
        // merchantName: [
        //   { required: true, message: "卖家名称不能为空", trigger: "change" },
        // ],
        // merchantPhone: [
        //   { required: true, message: "卖家手机号不能为空", trigger: "change" },
        // ],
        // merchantAddress: [
        //   { required: true, message: "卖家地址不能为空", trigger: "change" },
        // ],
        name: [
          { required: true, message: "商品名称不能为空", trigger: "change" },
        ],
        tag: [
          { required: true, message: "是否特供不能为空", trigger: "change" },
        ],
        category: [
          { required: true, message: "商品类目不能为空", trigger: "change" },
        ],
        adPrice: [
          { required: true, message: "营销价格不能为空", trigger: "change" },
        ],
        sku: [
          { required: true, message: "商品sku不能为空", trigger: "change" },
        ],
        mainGraph: [
          {
            required: true,
            message: "商品主图地址不能为空",
            trigger: "change",
          },
        ],
        goodsGraph: [
          { required: true, message: "商品图地址不能为空", trigger: "change" },
        ],
        detailInfo: [
          {
            required: true,
            message: "商品详情介绍不能为空",
            trigger: "change",
          },
        ],
        deliveryTime: [
          { required: true, message: "发货失效不能为空", trigger: "change" },
        ],
        specsArr: [
          {
            required: true,
            message: "商品规格信息不能为空",
            trigger: "change",
          },
        ],
        isRecomm: [
          { required: true, message: "是否推荐不能为空", trigger: "change" },
        ],
        specsPriceArr: [
          {
            required: true,
            message: "商品规格价格库存信息不能为空",
            trigger: "change",
          },
        ],
        postagesId: [
          {
            required: false,
            message: "邮费模版不能为空",
            trigger: "change",
          },
        ],
      },
      form: {
        id: null,
        shopId: null,
        type: null,
        name: null,
        tag: null,
        category: null,
        adPrice: null,
        mainGraph: null,
        goodsGraph: null,
        detailInfo: null,
        postagesId: null, // 邮费模版
        specsArr: [], //商品规格信息 [{"type":"颜色","items":[{"n":"蓝色","i":"图标地址(可为空)"},{"n":"黑色","i":"图标地址(可为空)"}]},{"type":"尺寸","items":[{"n":"37","i":"图标地址(可为空)"}]}]
        specsPriceArr: [], //商品规格价格库存信息
        buyLimit: null,
        isEnterpriseUser: 0,// 是否支持企业：0，支持普通用户，1:支持企业用户
        deliveryTime: null, // 发货失效
        porpAge: null, // 适用年龄
        limitedTime: 0, // 限时活动时间
        porpSex: null, // 适用性别
        porpStyle: null, // 风格
        porpNum: null, // 货号
        porpOntime: null, // 上市时间
        porpOrigin: null, // 产地
        expendRate: null, // 贡献值比例
        raffleNum: null, // 抽奖次数
        vcoinRate: null, // 赠送交易币的比例
        bonusRate: null, //赠送推广佣金的比例
        redpacketRate: null, // 赠送现金红包的比例
        balanceRate: null, // 赠送现金余额的比例
        exchangeNum: null, //赠送兑换券的数量
        exchangeValue: null, // 赠送兑换券的面值
        deductionNum: null, // 赠送抵扣券的数量
        deductionValue: null, //赠送抵扣券的面值
        isRecomm: null, // 是否推荐
        supplyPrice: null, // 供货价格
        keywords: "",
        merchantName:'',
        merchantPhone:'',
        merchantAddress:''
      },
      btnLoading: false,
      editorOption: {
        placeholder: "请输入",
        theme: "snow",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ header: 1 }, { header: 2 }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rt1" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ["link", "image", "video"],
              ["clean"],
            ],
            handlers: {
              //此处是图片上传时候需要使用到的
              image: (value) => {
                if (value) {
                  // 点击图片
                  document.querySelector(".uploadFile input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              upload: (value) => {
                if (value) {
                  // 点击图片
                  document.querySelector(".uploadFile input").click();
                }
              },
            },
          },
          clipboard: {
            // 剪切板事件
            matchers: [
              ["img", this.handlePasteImg], // 匹配图片剪切板
            ],
          },
        },
      },
      isSddSpecification: true, // 添加规格的按钮是否可用
      batch: {
        option: [],
        batchType: [],
        count: null,
        price: null,
      }, // 批量执行的一些数据
      postagesOption: [], // 邮费模版
      giftConfigs: [], // 模版配置
    };
  },
  created() {
    this.getPostagesList();
  },
  mounted() {
    this.getGiftConfigs();
    const id = this.$route.params.id;
    if (id && id !== 0) {
      this.form.id = id;
      this.getById();
    }
  },
  methods: {
    /**
     * 返回列表
     */
    jumpList() {
      this.$confirm("当前编辑的内容未保存，是否立即返回商品列表？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$router.push({ path: "/product/list" });
      });
    },
    /**
     * 查询编辑详情
     */
    getById() {
      getGoodsEditDetail({ id: this.form.id }).then((resp) => {
        if (resp.bizcode === 100) {
          const data = resp.data;
          this.form = {
            id: data.id,
            shopId: data.shopId,
            type: data.type,
            name: data.name,
            tag: data.tag,
            adPrice: data.adPrice,
            detailInfo: data.detailInfo,
            postagesId: data.postagesId, // 邮费模版
            buyLimit: data.buyLimit,
            isEnterpriseUser: data.isEnterpriseUser,
            deliveryTime: data.deliveryTime, // 发货失效
            porpAge: data.porpAge, // 适用年龄
            porpSex: data.porpSex, // 适用性别
            limitedTime: data.limitedTime, // 限时活动时间
            porpStyle: data.porpStyle, // 风格
            porpNum: data.porpNum, // 货号
            porpOntime: data.porpOntime, // 上市时间
            porpOrigin: data.porpOrigin, // 产地
            expendRate: data.expendRate ? data.expendRate * 100 : 0,
            raffleNum: data.raffleNum,
            vcoinRate: data.vcoinRate ? data.vcoinRate : 0,
            bonusRate: data.bonusRate ? data.bonusRate : 0,
            redpacketRate: data.redpacketRate ? data.redpacketRate : 0,
            balanceRate: data.balanceRate ? data.balanceRate : 0,
            exchangeNum: data.exchangeNum,
            exchangeValue: data.exchangeValue,
            deductionNum: data.deductionNum,
            deductionValue: data.deductionValue,
            isRecomm: data.isRecomm,
            supplyPrice: data.supplyPrice,
            merchantName:data.merchantName,
            merchantPhone:data.merchantPhone,
            merchantAddress:data.merchantAddress
          };
          // 主图地址
          if (data.mainGraph) {
            const attDataArr = [];
            attDataArr.push({
              url: data.mainGraph,
              dbUrl: data.mainGraph,
              name: getFileName(data.mainGraph),
            });
            this.form.mainGraph = attDataArr;
          }
          // 商品图地址
          if (data.goodsGraph) {
            const attDataArr = [];
            const defImgArr = data.goodsGraph.split(",");
            defImgArr.map((item) => {
              attDataArr.push({
                url: item,
                dbUrl: item,
                name: getFileName(item),
              });
            });
            this.form.goodsGraph = attDataArr;
          }
          // 类目
          if (data.category) {
            const categoryArr = data.category.split(",");
            const arr = [];
            categoryArr.map((item) => {
              arr.push(parseInt(item, 10));
            });
            this.form.category = arr;
          }
          // 商品的规格
          if (data.specs) {
            console.log("商品的规格", data.specs);
            const specsArr = JSON.parse(data.specs);
            const newSpecsArr = [];
            specsArr.map((item) => {
              if (Array.isArray(item.items)) {
                item.items.forEach((itemsItem, itemsIndex) => {
                  itemsItem.specsId = itemsIndex + 1;
                });
              }
              newSpecsArr.push({
                ...item,
                isEdit: false,
              });
            });
            console.log("商品的规格-2", newSpecsArr);
            this.form.specsArr = newSpecsArr;
          }
          // 商品的规格的详细规格和库存信息
          console.log("商品的规格的详细规格和库存信息", data.combs);
          if (data.combs) {
            const combs = data.combs;
            const newCombArr = [];
            combs.map((item, index) => {
              newCombArr.push({
                n: item.combNames,
                p: item.price,
                s: item.stock,
                m: item.mchNo,
                supplyPrice: item.supplyPrice,
                id: item.id,
                specsId: item.specsId || index + 1,
              });
            });
            this.form.specsPriceArr = newCombArr;

            console.log(
              "商品的规格的详细规格和库存信息",
              this.form.specsPriceArr
            );
          }
        }
      });
    },

    /**
     * 查询可赠送的赠品
     */
    getGiftConfigs() {
      getGiftConfigs().then((resp) => {
        if (resp && resp.bizcode === 100) {
          this.giftConfigs = resp.data || [];
        }
      });
    },

    findGiftConfigs(keyName) {
      const giftConfigs = this.giftConfigs;
      const isIncludes =
        giftConfigs.find((item) => item.key === keyName) !== undefined;
      return isIncludes;
    },

    /**
     * 强制刷新
     * @param e
     */
    forceUpdate(e) {
      this.$forceUpdate();
    },
    /**
     * 获取邮费模版
     */
    getPostagesList() {
      const params = {
        page: 1,
        pageSize: 99,
      };
      getPostagesList(params).then((resp) => {
        if (resp && resp.bizcode === 100) {
          this.postagesOption = resp.data.entitys;
        }
      });
    },
    /**
     * 获取主营类目
     * @param type
     * @param resultArr
     */
    getCategoryValueFunc(type, resultArr) {
      if (type === "formCategory") {
        this.form.category = resultArr;
      }
    },
    /**
     * 获取店铺
     * @param type
     * @param resultArr
     */
    getShopValueFunc(type, resultArr) {
      if (type === "formShop") {
        this.form.shopId = resultArr;
      }
    },
    /**
     *  获取图片的值
     * @param type
     * @param value
     */
    getImgsValueFunc(type, value) {
      if (type === "mainGraph") {
        this.form.mainGraph = value;
      } else if (type === "goodsGraph") {
        this.form.goodsGraph = value;
      }
    },

    /**
     * 添加 or 编辑 商品
     */
    saveAddOrEditData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const form = this.form;
          const specsArr =
            Array.isArray(form.specsArr) &&
            form.specsArr.map((o) => ({
              items: o.items,
              type: o.type,
            }));
          const params = {
            ...form,
            specsInfo: JSON.stringify(specsArr),
            specsPriceInfo: JSON.stringify(form.specsPriceArr),
            category: form.category.length !== 0 ? form.category.join(",") : "",
          };
          console.log("-----1", form.specsPriceArr);
          if (form.mainGraph && form.mainGraph.length !== 0) {
            const urlArr = form.mainGraph.map((obj) => obj["dbUrl"]);
            params.mainGraph = urlArr.join(",");
          }
          if (form.goodsGraph && form.goodsGraph.length !== 0) {
            const urlArr = form.goodsGraph.map((obj) => obj["dbUrl"]);
            params.goodsGraph = urlArr.join(",");
          }
          if (form.porpOntime) {
            params.porpOntime = moment(form.porpOntime).format("YYYY-MM-DD");
          }
          // 类型未普通专区
          if (params.type === 0) {
            delete params.expendRate;
            delete params.raffleNum;
            delete params.vcoinRate;
            delete params.bonusRate;
            delete params.redpacketRate;
            delete params.balanceRate;
            delete params.exchangeNum;
            delete params.exchangeValue;
            delete params.deductionNum;
            delete params.deductionValue;
          } else {
            params.expendRate = form.expendRate ? form.expendRate / 100 : 0;
            params.vcoinRate = form.vcoinRate ? form.vcoinRate / 100 : 0;
            params.bonusRate = form.bonusRate ? form.bonusRate / 100 : 0;
            params.redpacketRate = form.redpacketRate
              ? form.redpacketRate / 100
              : 0;
            params.balanceRate = form.balanceRate ? form.balanceRate / 100 : 0;
          }

          delete params.specsArr;
          delete params.specsPriceArr;
          if (!form.id || form.id === 0) {
            delete form.id;
          }
          this.btnLoading = true;
          editGoods(params)
            .then((res) => {
              if (res && res.bizcode === 100) {
                this.$notify({
                  title: "成功",
                  message: "保存成功",
                  type: "success",
                  duration: 2000,
                });
                this.$router.push({
                   path: `/product/list?isEdit=true`, 
            
                });
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },

    handlePasteImg: function(node, delta) {
      // 调整为上传，给回路径
      let _self = this;
      let base64code =
        delta &&
        delta.ops &&
        delta.ops[0] &&
        delta.ops[0]["insert"] &&
        delta.ops[0]["insert"]["image"]; // 2.1
      if (
        base64code &&
        base64code.indexOf("http://") !== 0 &&
        base64code.indexOf("https://") !== 0
      ) {
        const loading = this.$loading({
          lock: true,
          text: "上传图片中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        // 已经上传的不处理，可自定义判断逻辑
        let file = _self.dataURLtoFile(base64code, "paste.png"); // 2.2
        const params = {
          type: UPLOAD_IMG_TYPE.BRAND,
          file: file,
        };
        // 调用后端服务器的接口
        uploadImage(params)
          .then((resp) => {
            if (resp.bizcode === 100) {
              // 获取富文本对象
              let quill = _self.$refs["myQuillEditor"].quill;
              let length = quill.selection.savedRange.index;
              quill.insertEmbed(length, "image", resp.data.dbUrl);
              quill.setSelection(length + 1);
            } else {
              Message({
                message: resp.msg,
                type: "error",
                duration: 3 * 1000,
              });
            }
          })
          .catch((e) => {
            this.$message.error(e.message);
            this.$refs.upload.clearFiles();
          })
          .finally(() => {
            this.loading = false;
            loading.close();
          });
        // 1、等待请求返回做不到同步，先返回空，在请求回调中再添加（这里监听函数接收职能接收同步的数据，特殊处理）
        delta.ops = [];
        return delta;
      } else {
        return delta;
      }
    },
    // 图片的base64编码转为图片文件
    dataURLtoFile: function(dataurl, name) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], name, { type: mime });
    },

    // 添加规格 start
    /**
     * 添加规格
     */
    addSpecification() {
      if (!this.isSddSpecification) {
        return;
      }
      const item = {
        type: null,
        isEdit: true,
        items: [],
      };
      this.form.specsArr.push(item);
      this.isSddSpecification = false; // 把按钮禁用
      this.$forceUpdate();
    },
    /**
     * 保存规格
     */
    savaSpecification(index, status, type) {
      this.form.specsArr[index].isEdit = status;
      this.isSddSpecification = true; // 把按钮启用
      if (type === "create") {
        // 添加规格item
        this.saveSpecificationItem(index);
      }
      this.$forceUpdate();
    },
    /**
     * 保存规格
     */
    deleteSpecification(index) {
      this.$confirm("确认要删除该规格吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.form.specsArr.splice(index, 1);
      });
    },
    /**
     * 添加规格items
     * @param index 父级索引
     */
    saveSpecificationItem(index) {
      const { specsPriceArr } = this.form;
      const maxId = specsPriceArr.length
        ? Math.max(...specsPriceArr.map((i) => i.specsId))
        : 1;
      console.log("添加规格items-----", maxId);
      this.form.specsArr[index].items.push({
        n: null, // 颜色
        i: null, // 图标地址(可为空)
        specsId: maxId + 1,
      });
      console.log(
        "添加规格items",
        this.form.specsArr[index].items,
        this.form.specsPriceArr,
        this.form
      );
      this.forceUpdate();
    },
    /**
     * 删除规格
     * @param index 父级索引
     * @param iIndex 子级索引
     */
    deleteSpecificationItem(index, iIndex) {
      if (iIndex === 0) {
        this.$message({
          message: "请保留至少一个规格",
          type: "warning",
        });
        return;
      }
      this.form.specsArr[index].items.splice(iIndex, 1);
      this.assemblyAttributeData();
    },
    // 上传详情里的图片
    handleFileUpload(file, index, iIndex) {
      const then_ = this;
      const loading = this.$loading({
        lock: true,
        text: "上传图片中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const params = {
        type: UPLOAD_IMG_TYPE.GOODS,
        file: file.file,
      };
      // 调用后端服务器的接口
      uploadImage(params)
        .then((resp) => {
          if (resp.bizcode === 100) {
            let quill = then_.$refs.myQuillEditor.quill;
            let length = quill.getSelection().index;
            quill.insertEmbed(length, "image", resp.data.dbUrl);
            quill.setSelection(length + 1);
          } else {
            Message({
              message: resp.msg,
              type: "error",
              duration: 3 * 1000,
            });
          }
        })
        .catch((e) => {
          this.$message.error(e.message);
          this.$refs.upload.clearFiles();
        })
        .finally(() => {
          loading.close();
        });
    },
    // 添加规格 end
    assemblyAttrBlur(item) {
      if (!item.n) {
        this.$message.error("请输入规格名称");
      }
    },
    /**
     * 组装属性，生成规格表格数据
     */
    assemblyAttributeData() {
      const { specsArr, specsPriceArr } = this.form;

      const priceMap = new Map(
        specsPriceArr.map((item) => [item.specsId, item])
      );

      // 当前最大 specsId，便于后面自增
      const maxId = specsPriceArr.length
        ? Math.max(...specsPriceArr.map((i) => i.specsId))
        : 0;

      let autoId = maxId + 1;
      const result = [];

      specsArr.forEach(({ items }) => {
        items.forEach((item) => {
          if (priceMap.has(item.specsId)) {
            // 已有价格：合并
            result.push({ ...item, ...priceMap.get(item.specsId) });
          } else {
            // 缺失价格：补空值
            result.push({
              n: item.n,
              p: null,
              s: null,
              m: null,
              specsId: autoId++,
            });
          }
        });
      });

      this.form.specsPriceArr = result;
      this.batch.option = result;
      this.forceUpdate();
    },
    // 生成数据
    getCombinations(data) {
      console.log("提取各属性的选项数组-1", data);
      // 提取各属性的选项数组
      const dimensions = data.map((d) => d.items.map((item) => item.n));
      // 计算笛卡尔积
      console.log("提取各属性的选项数组-2", dimensions, data);
      // const combinations = dimensions.reduce(
      //   (acc, current) =>{
      //         console.log('提取各属性的选项数组-3',acc,current);
      //   return  acc.flatMap((comb) => current.map((item) => [...comb, item]))
      //   },
      //   [[]]
      // );
      // console.log('提取各属性的选项数组-4',combinations);
      // // 转换为目标格式
      // const results = combinations.map((items) => ({
      //   n: items.join("♧"),
      //   p: null,
      //   s: null,
      //   m: null,
      //   id: items.id || null
      // }));
      // const batchName = combinations.map((items) => ({
      //   n: items.join("♧"),
      // }));

      let results = [];
      data.forEach((item, index) => {
        for (let ele of item.items) {
          results.push({
            n: ele.n,
            p: null,
          });
        }
      });
      console.log("提取各属性的选项数组-4", results);

      this.batch.option = results;

      return results;
    },
    // 批量填写
    batchFill() {
      const batchType = this.batch.batchType;
      const price = this.batch.price;
      const count = this.batch.count;
      const specsPriceArr = this.form.specsPriceArr;
      if (specsPriceArr && Object.keys(specsPriceArr).length !== 0) {
        specsPriceArr.map((item) => {
          if (batchType.includes(item.n)) {
            if (price && price !== 0) {
              item.p = price;
            }
            if (count && count !== 0) {
              item.s = count;
            }
          } else {
            if (price && price !== 0) {
              item.p = price;
            }
            if (count && count !== 0) {
              item.s = count;
            }
          }
        });
      }
      this.forceUpdate();
    },
    // 删除规格
    async onDeleteSpecs(item, index) {
      console.log("删除规格", item);
      if (!item.id) {
        this.form.specsPriceArr.splice(index, 1);
        return;
      }
      const { bizcode } = await deleteGoodsSpecs({ id: item.id });
      if (bizcode === 100) {
        this.form.specsPriceArr.splice(index, 1);
        this.forceUpdate();
      }
    },
  },
};
</script>

<template>
  <div class="app-container add_edit_product_warp">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-position="left"
      label-width="150px"
      style="width: calc(100% - 100px); padding:20px 50px;"
    >
      <!--      商品详细数据-->
      <el-card class="box-card card_but" shadow="hover">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <div class="text item">
          <el-row :gutter="40">
            <el-col :span="8">
              <el-form-item label="商品名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品类型" prop="type">
                <el-select
                  v-model="form.type"
                  placeholder="类型"
                  style="width: 100%"
                  class="filter-item"
                  clearable
                >
                  <el-option
                    v-for="item in PRODUCT_TYPE_LIST"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否特供" prop="tag">
                <el-select
                  v-model="form.tag"
                  placeholder="类型"
                  style="width: 100%"
                  class="filter-item"
                  clearable
                >
                  <el-option
                    v-for="item in PRODUCT_TYPE_TAG"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="8">
              <el-form-item label="店铺" prop="shopId">
                <ShopOption
                  :refValue="form.shopId"
                  class="filter-item"
                  type="formShop"
                  :styleRef="{ width: '100%' }"
                  @valueFunc="getShopValueFunc"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属类目" prop="category">
                <Category
                  :value="form.category"
                  @valueFunc="getCategoryValueFunc"
                  type="formCategory"
                  :styleRef="{ width: '100%' }"
                  :showLevels="true"
                  :isMultiple="false"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="限购数量" prop="buyLimit">
                <el-input v-model="form.buyLimit" placeholder="0表示不限" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40"> 
            <el-col :span="10">
              <el-form-item label="是否支持企业用户" prop="isEnterpriseUser">
                 <el-radio-group v-model="form.isEnterpriseUser" @change="saveUserType">
                    <el-radio
                      :label="item.key"
                      v-for="item in YES_NO_LIST"
                      :key="item.key"
                      >{{ item.value }}</el-radio
                    >
                  </el-radio-group>
                <!-- <el-input v-model="form.isEnterpriseUser" placeholder="0表示不限" /> -->
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="40">
            <el-col :span="24">
              <el-form-item label="关键字" prop="keywords">
                <el-input
                  type="textarea"
                  v-model="form.keywords"
                  placeholder="支持多个，用英文逗豆分隔"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            
            <el-col :span="12">
              <el-form-item label="卖家名称" prop="merchantName">
                <el-input v-model="form.merchantName" placeholder="请输入卖家名称" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="卖家手机号" prop="merchantPhone">
                <el-input v-model="form.merchantPhone" placeholder="请输入卖家手机号" />
              </el-form-item>
            </el-col>
            
          </el-row>
          <el-row :gutter="40">
            <el-col :span="24">
              <el-form-item label="卖家地址" prop="merchantAddress">
                <el-input v-model="form.merchantAddress" placeholder="请输入卖家地址" />
              </el-form-item>
            </el-col>
          </el-row>

        </div>
      </el-card>
      <!--      优选设置-->
      <el-card class="box-card card_but" shadow="hover" v-if="form.type !== 0">
        <div slot="header" class="clearfix">
          <span>优选设置</span>
        </div>
        <div class="text item">
          <el-row :gutter="40">
            <el-col :span="8" v-if="findGiftConfigs('expend')">
              <el-form-item label="赠送贡献值比例" prop="porpAge">
                <el-input v-model="form.expendRate" placeholder="请输入">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('redpacket')">
              <el-form-item label="赠送抽奖次数" prop="porpAge">
                <el-input v-model="form.raffleNum" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('vcoin')">
              <el-form-item label="赠送交易币的比例" prop="vcoinRate">
                <el-input v-model="form.vcoinRate" placeholder="请输入">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('bonus')">
              <el-form-item label="赠送推广佣金的比例" prop="bonusRate">
                <el-input v-model="form.bonusRate" placeholder="请输入">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('balance')">
              <el-form-item label="赠送现金红包的比例" prop="redpacketRate">
                <el-input v-model="form.redpacketRate" placeholder="请输入">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('balance')">
              <el-form-item label="赠送现金余额的比例" prop="balanceRate">
                <el-input v-model="form.balanceRate" placeholder="请输入">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('exchange')">
              <el-form-item label="赠送兑换券的数量" prop="exchangeNum">
                <el-input v-model="form.exchangeNum" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('exchange')">
              <el-form-item label="赠送兑换券的面值" prop="exchangeValue">
                <el-input v-model="form.exchangeValue" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('deduction')">
              <el-form-item label="赠送抵扣券的数量" prop="deductionNum">
                <el-input v-model="form.deductionNum" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('deduction')">
              <el-form-item label="赠送抵扣券的面值" prop="deductionValue">
                <el-input v-model="form.deductionValue" placeholder="请输入" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-card>

      <!--      商品规格设置-->
      <el-card class="box-card card_but" shadow="hover">
        <div slot="header" class="clearfix">
          <span>销售信息</span>
        </div>
        <div class="text item">
          <el-form-item label="发货时效" prop="deliveryTime">
            <el-radio-group v-model="form.deliveryTime">
              <el-radio
                :label="item.key"
                v-for="item in PRODUCT_DELIVERY_TIME"
                :key="item.key"
                >{{ item.value }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="商品属性" prop="specsInfo">
            <div>
              <!--                该商品下可添加的SKU上限为136个，规范配置销售属性有助于商品转化。-->
            </div>
            <div class="specification_warp">
              <!-- 循环单个规格-->
              <div
                v-show="form.specsArr && form.specsArr.length !== 0"
                v-for="(item, index) in form.specsArr"
                :key="index"
                class="specification_item"
              >
                <!-- 规格标题-->
                <div v-if="item.isEdit" class="specification_item_isEdit">
                  <el-input
                    size="medium"
                    v-model="item.type"
                    style="width: 200px"
                    placeholder="请输入规格类型标题"
                    @input="forceUpdate($event)"
                  />
                  <el-button
                    type="primary"
                    size="mini"
                    class="but_left"
                    @click="savaSpecification(index, false, 'create')"
                    >保存</el-button
                  >
                </div>
                <div v-else>
                  <span style="margin-right: 60px">{{ item.type }}</span>
                  <el-button
                    type="success"
                    size="mini"
                    class="but_left"
                    @click="savaSpecification(index, true, 'update')"
                    >编辑</el-button
                  >
                  <el-button
                    size="mini"
                    class="but_left"
                    @click="deleteSpecification(index)"
                    >删除</el-button
                  >
                </div>
                <!-- 规格具体项-->
                <div class="specification_item_i">
                  <div
                    v-for="(iItem, iIndex) in item.items"
                    :key="iIndex"
                    class="specification_item_i_item"
                  >
                    <div class="img_">
                      <!--                    <el-upload-->
                      <!--                      action="#"-->
                      <!--                      list-type="picture-card"-->
                      <!--                      :auto-upload="false"-->
                      <!--                      :http-request="handleFileUpload"-->
                      <!--                      v-model="iItem.i"-->
                      <!--                    >-->
                      <!--                      <img :src="iItem.i" v-if="iItem.i" />-->
                      <!--                      <img src="@/assets/common/def_img.png" v-else/>-->
                      <!--                    </el-upload>-->
                      <img src="@/assets/common/def_img.png" />
                    </div>
                    <el-input
                      v-model="iItem.n"
                      placeholder="名称(必填)"
                      style="width: 100%"
                      size="small"
                      @change="assemblyAttributeData"
                      @input="forceUpdate($event)"
                      @blur="assemblyAttrBlur(iItem)"
                    />
                    <div
                      class="delete_img_"
                      @click="deleteSpecificationItem(index, iIndex)"
                    >
                      <img src="@/assets/common/delete.png" />
                    </div>
                  </div>
                  <div
                    class="add_specification_item_i_item"
                    @click="saveSpecificationItem(index)"
                    v-show="item.items && item.items.length !== 0"
                  >
                    +
                  </div>
                </div>
              </div>
              <!-- 添加单个规格-->
              <div
                :class="
                  isSddSpecification
                    ? 'add_specification_but'
                    : 'add_specification_but add_specification_but_no'
                "
                @click="addSpecification"
              >
                + 添加规格
              </div>
            </div>
          </el-form-item>
          <el-form-item label="商品规格" prop="specsPriceInfo">
            <div class="attribute_warp">
              <!-- 批量修改-->
              <div class="batch_warp">
                <el-select
                  v-model="batch.batchType"
                  placeholder="请选择"
                  multiple
                  collapse-tags
                >
                  <el-option
                    v-for="item in batch.option"
                    :key="item.n"
                    :label="item.n"
                    :value="item.n"
                  >
                  </el-option>
                </el-select>
                <el-input
                  v-model="batch.price"
                  style="width: 200px"
                  placeholder="价格"
                  class="mar_left"
                  type="text"
                >
                  <div slot="suffix" class="">元</div>
                </el-input>
                <el-input
                  v-model="batch.count"
                  style="width: 200px"
                  placeholder="数量"
                  class="mar_left"
                  type="text"
                >
                  <div slot="suffix" class="">件</div>
                </el-input>
                <el-button round @click="batchFill" class="mar_left"
                  >批量填写</el-button
                >
              </div>
              <el-table
                :data="form.specsPriceArr"
                style="width: 100%"
                max-height="450"
                :header-cell-style="{
                  color: '#000000',
                  background: '#dcdfe642',
                }"
                size="mini"
              >
                >
                <el-table-column prop="n" label="名称"> </el-table-column>
                <el-table-column prop="p" label="价格">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.p"
                      placeholder="请输入"
                      size="small"
                      type="text"
                      @input="forceUpdate($event)"
                    >
                      <div slot="suffix" class="">元</div>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="s" label="库存数量">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.s"
                      placeholder="请输入"
                      size="small"
                      type="text"
                      @input="forceUpdate($event)"
                    >
                      <div slot="suffix" class="">件</div>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="m" label="商家编号">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.m"
                      placeholder="请输入"
                      size="small"
                      @input="forceUpdate($event)"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="supplyPrice" label="供货价">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.supplyPrice"
                      placeholder="请输入"
                      size="small"
                      type="text"
                      @input="forceUpdate($event)"
                    >
                      <div slot="suffix" class="">元</div>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="150px">
                  <template slot-scope="scope">
                    <div
                      class="delete-specs-price"
                      @click="onDeleteSpecs(scope.row, scope.$index)"
                    >
                      删除
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <el-form-item label="原价" prop="adPrice">
            <el-input
              v-model="form.adPrice"
              placeholder="请输入"
              style="width: 60%"
            />
          </el-form-item>
          <el-form-item label="供货价格" prop="supplyPrice">
            <el-input
              v-model="form.supplyPrice"
              placeholder="请输入"
              style="width: 60%"
            />
          </el-form-item>
          <el-form-item label="是否推荐" prop="isRecomm">
            <el-radio-group v-model="form.isRecomm">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-card>

      <!--      商品主图，详情设置-->
      <el-card class="box-card card_but" shadow="hover">
        <div slot="header" class="clearfix">
          <span>图文描述</span>
        </div>
        <div class="text item">
          <el-form-item label="商品主图地址" prop="mainGraph">
            <UploadList
              :typeProps="UPLOAD_IMG_TYPE.BRAND"
              @valueFunc="getImgsValueFunc"
              paramsType="mainGraph"
              :model="form.mainGraph"
              :maxCount="1"
            />
          </el-form-item>

          <el-form-item label="商品图地址" prop="goodsGraph">
            <UploadList
              :typeProps="UPLOAD_IMG_TYPE.BRAND"
              @valueFunc="getImgsValueFunc"
              paramsType="goodsGraph"
              :model="form.goodsGraph"
              :maxCount="6"
            />
          </el-form-item>

          <el-form-item label="商品详情介绍" prop="detailInfo">
            <quill-editor
              v-model="form.detailInfo"
              class="content_warp"
              ref="myQuillEditor"
              :options="editorOption"
            ></quill-editor>
          </el-form-item>
        </div>
      </el-card>

      <!--      类目属性-->
      <el-card class="box-card card_but" shadow="hover">
        <div slot="header" class="clearfix">
          <span>类目属性</span>
        </div>
        <div class="text item">
          <el-row :gutter="40">
            <el-col :span="8">
              <el-form-item label="适用年龄" prop="porpAge">
                <el-input v-model="form.porpAge" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="适用性别" prop="porpSex">
                <el-input v-model="form.porpSex" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="风格" prop="porpStyle">
                <el-input v-model="form.porpStyle" placeholder="请输入" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="8">
              <el-form-item label="货号" prop="porpNum">
                <el-input v-model="form.porpNum" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上市时间" prop="porpOntime">
                <el-date-picker
                  v-model="form.porpOntime"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="产地" prop="porpOrigin">
                <el-input v-model="form.porpOrigin" placeholder="请输入" />
              </el-form-item>
            </el-col>

            <!-- 是否限时 -->
             <el-col :span="8">
              <el-form-item label="是否限时" prop="limitedTime">
                <el-radio-group v-model="form.limitedTime">
                  <el-radio :label="1" :key="1">是</el-radio>
                  <el-radio :label="0" :key="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

          </el-row>
        </div>
      </el-card>

      <!--      邮费模版-->
      <el-card class="box-card card_but" shadow="hover">
        <div slot="header" class="clearfix">
          <span>物流服务</span>
        </div>
        <div class="text item">
          <el-form-item label="邮费模版" prop="postagesId">
            <el-select
              v-model="form.postagesId"
              placeholder="选择邮费模版"
              style="width: 100%"
              class="filter-item"
              clearable
            >
              <el-option
                v-for="item in postagesOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </div>
      </el-card>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="jumpList">取消</el-button>
      <el-button type="primary" @click="saveAddOrEditData" :loading="btnLoading"
        >确定</el-button
      >
    </div>
    <el-upload
      action="#"
      list-type="picture-card"
      class="uploadFile"
      :limit="1"
      :show-file-list="false"
      :http-request="handleFileUpload"
      v-show="false"
    >
    </el-upload>
  </div>
</template>

<style scoped lang="scss">
.add_edit_product_warp {
  background-color: #dcdfe642;
  padding: 20px 4%;
}

.card_but {
  margin-bottom: 20px;
  padding: 20px;
}

//规格
.specification_warp {
  background: #f7f8fa;
  padding: 10px;

  .but_left {
    margin-left: 10px;
  }

  .specification_item {
    margin-bottom: 10px;

    .specification_item_isEdit {
      display: flex;
    }

    .specification_item_i {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .specification_item_i_item {
        width: 25%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-right: 20px;

        .img_ {
          height: 26px;
          width: 28px;
          border: 1px dashed #d7dbe0;
          margin-right: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 6px;
          cursor: pointer;

          img {
            width: 50%;
            height: 50%;
          }

          ::v-deep .el-upload--picture-card {
            height: 34px;
            width: 34px;
            line-height: 38px;
          }
        }

        .delete_img_ {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
          cursor: pointer;

          img {
            width: 20px;
            height: 20px;
          }
        }
      }

      .add_specification_item_i_item {
        border: 1px solid rgba(61, 94, 255, 0.15);
        border-radius: 10px;
        width: 32px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
      }

      .add_specification_item_i_item:hover {
        color: #111;
        background: #ebecf0;
        border-color: #ebecf0;
      }
    }
  }

  .add_specification_but {
    border: 1px solid rgba(61, 94, 255, 0.15);
    border-radius: 10px;
    width: 60%;
    height: 41px;
    text-align: center;
    cursor: pointer;
  }

  .add_specification_but:hover {
    color: #111;
    background: #ebecf0;
    border-color: #ebecf0;
  }

  .add_specification_but_no {
    border: 1px solid rgba(61, 94, 255, 0.15);
    cursor: not-allowed;
  }
}

@media screen and (max-width: 1980px) {
  .attribute_warp {
    width: 100%;
  }
}

@media screen and (min-width: 1980px) {
  .attribute_warp {
    width: 60%;
  }
}

.attribute_warp {
  //width: 60%;
  .attribute_table_header_warp {
    background-color: red;
  }

  .batch_warp {
    display: flex;
    margin-bottom: 10px;
  }

  .mar_left {
    margin-left: 10px;
  }

  ::v-deep .el-input__suffix {
    top: 6px;
  }
}

.dialog-footer {
  text-align: center;
}

.content_warp {
  .uploadFile {
    width: 0;
    height: 0;
    display: none;
  }

  ::v-deep {
    .ql-container {
      min-height: 400px;
    }

    .ql-editor {
      min-height: 400px;
    }
  }
}

.delete-specs-price {
  border: 1px solid #7934f6;
  border-radius: 5px;
  width: 100px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28rpx;
  color: #7934f6;
  margin-left: 20rpx;
  cursor: pointer;
}
</style>
